import React from 'react'
import GiftCards from '../../components/User/Giftcards';

const GiftCardsPage = () => {
  return (
    <GiftCards />
  )
}

export default GiftCardsPage;